import { Reveal, StaggerGroup, StaggerItem } from "./Reveal";
import { PillButton } from "./PillButton";
import { AREE_INTERVENTO } from "../data/content";
import { ArrowRight, Check, Sparkles } from "lucide-react";

export const AreeInterventoSection = ({ id }) => {
  return (
    <section id={id} className="scroll-mt-24 py-16 md:py-24" data-testid="aree-intervento-list">
      <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-4">
        {AREE_INTERVENTO.map((area) => (
          <Reveal key={area.n}>
            <article
              className="bg-sand border border-border rounded-2xl p-8 md:p-12 grid md:grid-cols-12 gap-8 md:gap-10"
              data-testid={`area-${area.n}`}
            >
              <div className="md:col-span-5">
                <span className="font-serif text-5xl md:text-6xl text-sage">{area.n}</span>
                <h3 className="font-serif text-3xl md:text-4xl text-ink leading-tight mt-4">{area.title}</h3>
                <p className="text-stone leading-relaxed mt-5">{area.intro}</p>
                {area.note && (
                  <div className="mt-6 flex items-start gap-3 bg-cream border border-border rounded-xl px-4 py-3">
                    <Sparkles size={18} className="text-sage-dark mt-0.5 shrink-0" />
                    <p className="text-sm text-stone leading-relaxed">{area.note}</p>
                  </div>
                )}
              </div>
              <div className="md:col-span-7 md:border-l md:border-border md:pl-10">
                <p className="text-xs uppercase tracking-[0.22em] text-sage-dark mb-5">Mi occupo di</p>
                <StaggerGroup className="grid sm:grid-cols-2 gap-x-8 gap-y-3">
                  {area.items.map((item, i) => (
                    <StaggerItem key={i} y={12}>
                      <div className="flex items-start gap-3">
                        <Check size={18} className="text-sage-dark mt-1 shrink-0" />
                        <span className="text-ink leading-snug">{item}</span>
                      </div>
                    </StaggerItem>
                  ))}
                </StaggerGroup>
              </div>
            </article>
          </Reveal>
        ))}

        <Reveal>
          <div className="mt-8 bg-ink text-cream rounded-2xl p-8 md:p-12 flex flex-col md:flex-row md:items-center justify-between gap-6">
            <div>
              <h3 className="font-serif text-3xl md:text-4xl">Non trovi la tua situazione?</h3>
              <p className="text-cream/70 mt-3 max-w-xl leading-relaxed">
                Ogni percorso è personale. Scrivimi il motivo del contatto e valuteremo insieme se e come procedere.
              </p>
            </div>
            <PillButton to="/contatti" variant="outline" className="border-cream/30 text-cream hover:bg-cream hover:text-ink" testid="aree-intervento-cta">
              Richiedi informazioni <ArrowRight size={18} />
            </PillButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
